"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderExceptions = void 0;
var OrderExceptions;
(function (OrderExceptions) {
    OrderExceptions["BAD_REQUEST"] = "BAD_REQUEST";
    OrderExceptions["CANNOT_CANCEL"] = "CANNOT_CANCEL";
    OrderExceptions["CANNOT_QUEUE_ORDER"] = "CANNOT_QUEUE_ORDER";
    OrderExceptions["CANNOT_REPROCESS"] = "CANNOT_REPROCESS";
    OrderExceptions["CANNOT_REPROCESS_LOST_ORDER"] = "CANNOT_REPROCESS_LOST_ORDER";
    OrderExceptions["DUPLICATE_ORDER"] = "DUPLICATE_ORDER";
    OrderExceptions["FAILED_CANCEL_AT_WAREHOUSE"] = "FAILED_CANCEL_AT_WAREHOUSE";
    OrderExceptions["FAILED_TO_RESTORE_INVENTORY"] = "FAILED_TO_RESTORE_INVENTORY";
    OrderExceptions["INVALID_ADDRESS"] = "INVALID_ADDRESS";
    OrderExceptions["INVALID_DATE"] = "INVALID_DATE";
    OrderExceptions["INVALID_DUTIES_MERCHANT_OF_RECORD_SKU_MAP"] = "INVALID_DUTIES_MERCHANT_OF_RECORD_SKU_MAP";
    OrderExceptions["INVALID_ORDER_ID"] = "INVALID_ORDER_ID";
    OrderExceptions["INVALID_ORDER_TRACKING_ID"] = "INVALID_ORDER_TRACKING_ID";
    OrderExceptions["INVALID_QUERY_PARAMETER"] = "INVALID_QUERY_PARAMETER";
    OrderExceptions["INVALID_SELLER"] = "INVALID_SELLER";
    OrderExceptions["INVALID_TEST_OPTIONS"] = "INVALID_TEST_OPTIONS";
    OrderExceptions["MISSING_REMOVAL_CONTEXT"] = "MISSING_REMOVAL_CONTEXT";
    OrderExceptions["MISSING_TEST_ORDER_CONTEXT"] = "MISSING_TEST_ORDER_CONTEXT";
    OrderExceptions["NOT_FOUND"] = "NOT_FOUND";
    OrderExceptions["ORDER_CANCELLED"] = "ORDER_CANCELLED";
    OrderExceptions["ORDER_SHIPPED"] = "ORDER_SHIPPED";
    OrderExceptions["STOCKOUT"] = "STOCKOUT";
    OrderExceptions["UNKNOWN_SKU"] = "UNKNOWN_SKU";
    OrderExceptions["INVALID_WAREHOUSE"] = "INVALID_WAREHOUSE";
    OrderExceptions["NOT_A_REMOVAL_ORDER"] = "NOT_A_REMOVAL_ORDER";
    OrderExceptions["INVALID_ORDER_STATUS"] = "INVALID_ORDER_STATUS";
})(OrderExceptions = exports.OrderExceptions || (exports.OrderExceptions = {}));
//# sourceMappingURL=OrderExceptions.js.map